import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/stores/StoresClient.tsx");
